export const INTRODUCTION = 'introduction';
export const OPTIONS = 'options';
export const CONTACT_INFO = 'contactInfo';
export const DISSERTATION_INFO = 'dissertationInfo';
export const FILE_UPLOAD = 'fileUpload';
export const REVIEW = 'review';

export const list = [
  INTRODUCTION,
  OPTIONS,
  CONTACT_INFO,
  DISSERTATION_INFO,
  FILE_UPLOAD,
  REVIEW,
];



// WEBPACK FOOTER //
// ./src/common/steps.js